<div class="w-[950px]">
  <ng-template #errorTemplate let-error let-refresh="refresh">
    <rxap-data-source-error [error]="error" [refresh]="refresh"></rxap-data-source-error>
  </ng-template>
  <div class="flex flex-col gap-y-4">
    @if (accordionDataSource.loading$ | async) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
    <mat-accordion *rxapDataSource="let data from accordionDataSource; errorTemplate: errorTemplate" [rxapPersistentAccordion]="data.uuid">

      <mat-expansion-panel expanded>

        <mat-expansion-panel-header>
          <mat-panel-title i18n>Account information</mat-panel-title>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <form #form="rxapForm" rxapForm>
            <rxap-data-grid [dataSource]="userInfoDataSource" mode="plain">

              <ng-container rxapDataGridRowDef="username">
                <th *rxapDataGridHeaderCellDef class="whitespace-nowrap" i18n>Email</th>

                <ng-template rxapDataGridEditCellDef>
                  <mat-form-field class="flex-grow" data-cy="form.user-edit.username">
                    <mat-label i18n>Username</mat-label>
                    <input
                      formControlName="username"
                      i18n-placeholder
                      matInput
                      placeholder="Enter username"
                      rxapRequired
                      type="text"
                    />
                    <mat-error *rxapControlError="let error; key: 'pattern'" data-cy="error.pattern">
                      <ng-container i18n
                      >Please input a correct email address
                      </ng-container>
                    </mat-error>
                    <mat-error *rxapControlError="let error; key: 'maxlength'" data-cy="error.maxlength">
                      <ng-container i18n>The maximal E-Mail length is 50</ng-container>
                    </mat-error>
                    <mat-error *rxapControlError="let error; key: 'required'" data-cy="error.required">
                      <ng-container i18n>Please enter a value</ng-container>
                    </mat-error>
                    <button mat-icon-button matSuffix rxapInputClearButton tabindex="-1">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </mat-form-field>
                </ng-template>

                <ng-template let-value rxapDataGridCellDef>{{ value }}</ng-template>
              </ng-container>

              <ng-container rxapDataGridRowDef="firstname">
                <th *rxapDataGridHeaderCellDef class="whitespace-nowrap" i18n>First name</th>

                <ng-template rxapDataGridEditCellDef>
                  <mat-form-field class="flex-grow">
                    <mat-label i18n>Firstname</mat-label>
                    <input
                      formControlName="firstname"
                      i18n-placeholder
                      matInput
                      placeholder="Enter firstname"
                      rxapRequired
                      type="text"
                    />
                    <button mat-icon-button matSuffix rxapInputClearButton tabindex="-1">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </mat-form-field>
                </ng-template>

                <ng-template let-value rxapDataGridCellDef>{{ value }}</ng-template>
              </ng-container>

              <ng-container rxapDataGridRowDef="lastname">
                <th *rxapDataGridHeaderCellDef class="whitespace-nowrap" i18n>Last name</th>

                <ng-template rxapDataGridEditCellDef>
                  <mat-form-field class="flex-grow">
                    <mat-label i18n>Lastname</mat-label>
                    <input
                      formControlName="lastname"
                      i18n-placeholder
                      matInput
                      placeholder="Enter lastname"
                      rxapRequired
                      type="text"
                    />
                    <button mat-icon-button matSuffix rxapInputClearButton tabindex="-1">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </mat-form-field>
                </ng-template>

                <ng-template let-value rxapDataGridCellDef>{{ value }}</ng-template>
              </ng-container>

              <ng-container rxapDataGridRowDef="role">
                <th *rxapDataGridHeaderCellDef class="whitespace-nowrap" i18n>Role</th>

                <ng-template let-value rxapDataGridCellDef>{{ value }}</ng-template>
              </ng-container>

              <ng-container rxapDataGridRowDef="company">
                <th *rxapDataGridHeaderCellDef class="whitespace-nowrap" i18n>Company</th>

                <ng-template let-value rxapDataGridCellDef>{{ value?.name }}</ng-template>
              </ng-container>

              <ng-container rxapDataGridRowDef="phone">
                <th *rxapDataGridHeaderCellDef class="whitespace-nowrap" i18n>Phone number</th>

                <ng-template rxapDataGridEditCellDef>
                  <mat-form-field class="flex-grow">
                    <mat-label i18n>Phone</mat-label>
                    <input
                      formControlName="phone"
                      i18n-placeholder
                      matInput
                      placeholder="Enter phone"
                      rxapRequired
                      type="text"
                    />
                    <button mat-icon-button matSuffix rxapInputClearButton tabindex="-1">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </mat-form-field>
                </ng-template>

                <ng-template let-value rxapDataGridCellDef>{{ value }}</ng-template>
              </ng-container>

              <ng-container rxapDataGridRowDef="street">
                <th *rxapDataGridHeaderCellDef class="whitespace-nowrap" i18n>Street</th>

                <ng-template rxapDataGridEditCellDef>
                  <mat-form-field class="flex-grow">
                    <mat-label i18n>Street</mat-label>
                    <input
                      formControlName="street"
                      i18n-placeholder
                      matInput
                      placeholder="Enter street"
                      rxapRequired
                      type="text"
                    />
                    <button mat-icon-button matSuffix rxapInputClearButton tabindex="-1">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </mat-form-field>
                </ng-template>

                <ng-template let-value rxapDataGridCellDef>{{ value }}</ng-template>
              </ng-container>

              <ng-container rxapDataGridRowDef="zip">
                <th *rxapDataGridHeaderCellDef class="whitespace-nowrap" i18n>Zip</th>

                <ng-template rxapDataGridEditCellDef>
                  <mat-form-field class="flex-grow">
                    <mat-label i18n>Zip</mat-label>
                    <input
                      formControlName="zip"
                      i18n-placeholder
                      matInput
                      placeholder="Enter zip"
                      rxapRequired
                      type="text"
                    />
                    <button mat-icon-button matSuffix rxapInputClearButton tabindex="-1">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </mat-form-field>
                </ng-template>

                <ng-template let-value rxapDataGridCellDef>{{ value }}</ng-template>
              </ng-container>

              <ng-container rxapDataGridRowDef="city">
                <th *rxapDataGridHeaderCellDef class="whitespace-nowrap" i18n>City</th>

                <ng-template rxapDataGridEditCellDef>
                  <mat-form-field class="flex-grow">
                    <mat-label i18n>City</mat-label>
                    <input
                      formControlName="city"
                      i18n-placeholder
                      matInput
                      placeholder="Enter city"
                      rxapRequired
                      type="text"
                    />
                    <button mat-icon-button matSuffix rxapInputClearButton tabindex="-1">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </mat-form-field>
                </ng-template>

                <ng-template let-value rxapDataGridCellDef>{{ value }}</ng-template>
              </ng-container>

              <ng-container rxapDataGridRowDef="country">
                <th *rxapDataGridHeaderCellDef class="whitespace-nowrap" i18n>Country</th>

                <ng-template rxapDataGridEditCellDef>
                  <mat-form-field class="flex-grow">
                    <mat-label i18n>Country</mat-label>
                    <mat-select formControlName="country" rxapCompareWith rxapRequired>
                      <mat-option
                        *rxapInputSelectOptions="let option"
                        [value]="option.value"
                      >
                        {{ option.display }}
                      </mat-option>
                    </mat-select>
                    <button
                      mat-icon-button
                      matSuffix
                      rxapInputClearButton
                      rxapStopPropagation
                      tabindex="-1"
                    >
                      <mat-icon>clear</mat-icon>
                    </button>
                  </mat-form-field>
                </ng-template>

                <ng-template let-value rxapDataGridCellDef>{{ value }}</ng-template>
              </ng-container>

            </rxap-data-grid>
          </form>

          <button (click)="openResetPasswordDialog()" color="primary" class="mt-4" mat-raised-button>
            <span class="flex flex-row justify-start items-center gap-2">
              <mat-icon class="grow-0" svgIcon="lock-reset"></mat-icon>
              <span class="grow-0" i18n>Reset password</span>
            </span>
          </button>
        </ng-template>

      </mat-expansion-panel>

      <mat-expansion-panel>

        <mat-expansion-panel-header>
          <mat-panel-title>
            <ng-container i18n>Multi-Factor Authentication</ng-container>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          @if (accordionDataSource.user()?.uuid) {
            <eurogard-user-mfa-settings [userUuid]="accordionDataSource.user()!.uuid!"></eurogard-user-mfa-settings>
          }
        </ng-template>

      </mat-expansion-panel>

      <mat-expansion-panel>

        <mat-expansion-panel-header>
          <mat-panel-title i18n>Notification settings</mat-panel-title>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <eurogard-alarming-settings-panel></eurogard-alarming-settings-panel>
        </ng-template>

      </mat-expansion-panel>


      <mat-expansion-panel>

        <mat-expansion-panel-header>
          <mat-panel-title i18n>Subscribed Machines for notifications</mat-panel-title>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <eurogard-subscribed-machines-panel [userUuid]="accordionDataSource.user()?.uuid"></eurogard-subscribed-machines-panel>
        </ng-template>

      </mat-expansion-panel>

      @if (hasPermissionDeviceInboxToken) {
        <mat-expansion-panel>

          <mat-expansion-panel-header>
            <mat-panel-title>
              <ng-container i18n>Inbox Registration Token</ng-container>
              <eurogard-feature-text-text class="ml-2"></eurogard-feature-text-text>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <ng-template matExpansionPanelContent>
            <eurogard-registration-token-form></eurogard-registration-token-form>
          </ng-template>

        </mat-expansion-panel>
      }

    </mat-accordion>
  </div>

</div>
